<app-dialog-header [title]="title" (closeClicked)="onDismiss()">
</app-dialog-header>

<mat-dialog-content>
  @if (message) {
    <p>{{ message }}</p>
  }
  @if (messages && messages.length) {
    <ul>
      @for (msg of messages; track msg) {
        <li>{{ msg }}</li>
      }
    </ul>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (buttonMode === "yes-no-cancel") {
    @if (showCancelButton) {
      <button mat-flat-button (click)="onDismiss()">Cancel</button>
    }
    <button mat-flat-button color="primary" (click)="onNo()">No</button>
  } @else if (buttonMode === "yes-no") {
    <button mat-flat-button color="primary" (click)="onDismiss()">No</button>
  } @else if (buttonMode === "ok-cancel" && showCancelButton) {
    <button mat-flat-button (click)="onDismiss()">Cancel</button>
  }
  <button mat-flat-button color="primary" (click)="onConfirm()">
    {{
      buttonMode === "yes-no" || buttonMode === "yes-no-cancel" ? "Yes" : "OK"
    }}
  </button>
</mat-dialog-actions>
